
import { blogEn } from './en/blog';
import { blogDe } from './de/blog';
import { blogFr } from './fr/blog';
import { blogLb } from './lb/blog';
import { blogTr } from './tr/blog';
import { commonEn } from './en/common';
import { commonDe } from './de/common';
import { commonFr } from './fr/common';
import { commonLb } from './lb/common';
import { commonTr } from './tr/common';
import { homeEn } from './en/home';
import { homeDe } from './de/home';
import { homeFr } from './fr/home';
import { homeLb } from './lb/home';
import { homeTr } from './tr/home';

const resources = {
  en: {
    blog: blogEn,
    common: commonEn,
    home: homeEn,
  },
  de: {
    blog: blogDe,
    common: commonDe,
    home: homeDe,
  },
  fr: {
    blog: blogFr,
    common: commonFr,
    home: homeFr,
  },
  lb: {
    blog: blogLb,
    common: commonLb,
    home: homeLb,
  },
  tr: {
    blog: blogTr,
    common: commonTr,
    home: homeTr,
  },
};

export default resources;
